/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */

import React, { useState, useEffect } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';

function SociollaTabs(props) {
  const {
    data,
    style,
    headerStyle,
    itemWidth,
    tabActive,
    setTabActive,
    testID,
  } = props;

  // eslint-disable-next-line no-unused-vars
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (tabActive) {
      const find = data.find((x) => x.value === tabActive);
      setContent((find && find.content) || '');
    }
  }, [tabActive]);

  return (
    <View testID={testID} style={[styles.container, style]}>
      <View
        style={[
          styles.tabBorderBottom,
          styles.tabHeader,
          isWeb ? {} : { justifyContent: 'flex-start', width: '100%' },
          headerStyle,
        ]}>
        {data.map((tab, idx) => {
          {
            return (
              <TouchableOpacity
                testID={
                  testID ? `${testID}-tab-${tab.value}` : `tab-${tab.value}`
                }
                key={'tab-sociolla-' + idx}
                style={[
                  styles.tabItem,
                  itemWidth ? { width: itemWidth } : { flex: 1 },
                  tab.value === tabActive ? styles.tabItemActive : {},
                ]}
                onPress={() => setTabActive(tab.value)}>
                <SociollaText
                  type={tab.value === tabActive ? 'medium' : ''}
                  style={{
                    fontSize: 12,
                    lineHeight: 19,
                    color: tab.value === tabActive ? Colors.blue8 : '#A3A8B1',
                    textAlign: 'center',
                  }}>
                  {tab.label}
                </SociollaText>
              </TouchableOpacity>
            );
          }
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  tabHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  tabBorderBottom: {
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  // eslint-disable-next-line react-native/no-color-literals
  tabItem: {
    paddingVertical: 15,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    alignSelf: 'center',
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
});

export default SociollaTabs;
